export enum EUserTypes {
  client = 'client',
  admin = 'admin',
  client_adming = 'client_admin',
}

export enum EUserPermissions {
  EvaluationNewProjects = 'ROLE_AVALIACAO_NOVOS_PROJETOS',
  BudgetControl = 'ROLE_CONTROLE_ORCAMENTARIO',
  UsersManagement = 'ROLE_GESTAO_USUARIOS',
  ROPA = 'ROLE_REGISTRO_OPERACAO_TRATAMENTO_DADOS',
  TPA = 'ROLE_ASSESSMENT_TERCEIROS',
  ALI = 'ROLE_TESTE_LEGITIMO_INTERESSE',
}
